import { render } from "./OnScreenDebugger.vue?vue&type=template&id=158ef2c8&scoped=true&ts=true"
import script from "./OnScreenDebugger.vue?vue&type=script&setup=true&lang=ts"
export * from "./OnScreenDebugger.vue?vue&type=script&setup=true&lang=ts"

import "./OnScreenDebugger.vue?vue&type=style&index=0&id=158ef2c8&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.22_typescript@5.8.3__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-158ef2c8"],['__file',"src/components/OnScreenDebugger.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "158ef2c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('158ef2c8', __exports__)) {
    api.reload('158ef2c8', __exports__)
  }
  
  module.hot.accept("./OnScreenDebugger.vue?vue&type=template&id=158ef2c8&scoped=true&ts=true", () => {
    api.rerender('158ef2c8', render)
  })

}


export default __exports__